// Avatar configuration for staff members
// Import all avatar images
const avatars = {
  0: require('../assets/images/Avatars/1.png'),
  1: require('../assets/images/Avatars/1.png'),
  2: require('../assets/images/Avatars/2.png'),
  3: require('../assets/images/Avatars/3.png'),
  4: require('../assets/images/Avatars/4.png'),
  5: require('../assets/images/Avatars/5.png'),
  6: require('../assets/images/Avatars/6.png'),
  7: require('../assets/images/Avatars/7.png'),
  8: require('../assets/images/Avatars/8.png'),
  9: require('../assets/images/Avatars/9.png'),
  10: require('../assets/images/Avatars/10.png'),
  11: require('../assets/images/Avatars/11.png'),
  12: require('../assets/images/Avatars/12.png'),
  13: require('../assets/images/Avatars/13.png'),
  14: require('../assets/images/Avatars/14.png'),
  15: require('../assets/images/Avatars/15.png'),
  16: require('../assets/images/Avatars/16.png'),
  17: require('../assets/images/Avatars/17.png'),
  18: require('../assets/images/Avatars/18.png'),
  19: require('../assets/images/Avatars/19.png'),
  20: require('../assets/images/Avatars/20.png'),
  21: require('../assets/images/Avatars/21.png'),
  22: require('../assets/images/Avatars/22.png'),
  23: require('../assets/images/Avatars/23.png'),
  24: require('../assets/images/Avatars/24.png'),
  25: require('../assets/images/Avatars/25.png'),
  26: require('../assets/images/Avatars/26.png'),
  27: require('../assets/images/Avatars/27.png'),
  28: require('../assets/images/Avatars/28.png'),
  29: require('../assets/images/Avatars/29.png'),
  30: require('../assets/images/Avatars/30.png'),
  31: require('../assets/images/Avatars/31.png'),
  32: require('../assets/images/Avatars/32.png'),
  33: require('../assets/images/Avatars/33.png'),
  34: require('../assets/images/Avatars/34.png'),
  35: require('../assets/images/Avatars/35.png'),
  36: require('../assets/images/Avatars/36.png'),
  37: require('../assets/images/Avatars/37.png'),
  38: require('../assets/images/Avatars/38.png'),
  39: require('../assets/images/Avatars/39.png'),
  40: require('../assets/images/Avatars/40.png'),
  41: require('../assets/images/Avatars/41.png'),
  42: require('../assets/images/Avatars/42.png'),
  43: require('../assets/images/Avatars/43.png'),
  44: require('../assets/images/Avatars/44.png'),
  45: require('../assets/images/Avatars/45.png'),
  46: require('../assets/images/Avatars/46.png'),
  47: require('../assets/images/Avatars/47.png'),
  48: require('../assets/images/Avatars/48.png'),
  49: require('../assets/images/Avatars/49.png'),
  50: require('../assets/images/Avatars/50.png'),
};

// Helper function to get avatar image
export const getAvatarImage = (avatarId) => {
  const id = parseInt(avatarId) || 1; // Default to avatar 1 if invalid
  return avatars[id+1] || avatars[1];
};

// Helper function to get avatar as URL (for img src)
export const getAvatarUrl = (avatarId) => {
  const id = parseInt(avatarId) || 1;
  try {
    return `/assets/images/Avatars/${id}.png`;
  } catch (error) {
    return `/assets/images/Avatars/1.png`;
  }
};

export default avatars;

